import store from "@/store/";
import haugazelService from "@/services/haugazelService"

export default async ({ from, to, next }) => {
  console.log('middleware - prefill');

  let possibleQueries = {
    codeAgent: "agent",
    elecOffre: "elec_product_id",
    gazOffre: "gas_product_id",
    gasOffre: "gas_product_id",
    pid: "pid",
    lang: "language"
  };

  let payload = {};
  let tmpOffer = null;
  let tmpType = '';

  for (let query in to.query) {
    if (possibleQueries[query] !== undefined) {
      let value = to.query[query].trim();
      if (query === "codeAgent") {
        if (value === 'AG000132') {
          store.commit('subscription/setAgentCustomId', value);
        } else {
          return next({name: 'NotFound'})
        }
      }
      if (query === "lang") {
        value = value.toLowerCase().substring(0, 2);
        payload[possibleQueries[query]] = value;
      } 
      if (query === "elecOffre" || query === "gazOffre" || query === 'gasOffre') {
        try {
          let allowedOffers = ["239","240","241","242"];
          if (allowedOffers.indexOf(value) == -1) {
            return next({name: 'NotFound'})
          }

          let response = await haugazelService.getProductByOffer(value);
          if (response && response.product) {
            if (!tmpType) {
              tmpType = response.product.contractType;
            }
            if(response.product.energy === "electricity") {
              payload["has_elec"] = 1;
              payload["elec_product_id"] = response.product.hgzId;
              payload["elec_is_forced_product"] = 1;
              payload["elec_duration"] = response.product.duration;

              if((tmpOffer && response.product.range !== tmpOffer.product.range) || !tmpOffer) {
                payload["gas_product_id"] = response.pairedOffer.product.hgzId;
                payload["gas_is_forced_product"] = 1;
                payload["gas_duration"] = response.pairedOffer.product.duration;
              }
            } else if(response.product.energy === "gas") {
              payload["has_gas"] = 1;
              payload["gas_product_id"] = response.product.hgzId;
              payload["gas_is_forced_product"] = 1;
              payload["gas_duration"] = response.product.duration;

              if((tmpOffer && response.product.range !== tmpOffer.product.range) || !tmpOffer) {
                payload["elec_product_id"] = response.pairedOffer.product.hgzId;
                payload["elec_is_forced_product"] = 1;
                payload["elec_duration"] = response.pairedOffer.product.duration;
              }
            }

            tmpOffer = tmpOffer ? tmpOffer : response;
          }
        } catch(error) {
          console.log(error)
        }
      } else {
        if(value !== null) { 
          payload[possibleQueries[query]] = value;
        }
      }
    }
  }
  if (!payload[possibleQueries.lang]) {
    payload[possibleQueries.lang] = 'fr';
  }

  try { 
    let payloadTA = {
      energies: [],
      type: tmpType == 'variable' ? 'var' : 'fix',
      purchase_id: payload[possibleQueries.pid],
      language: payload[possibleQueries.lang]
    };
    if (payload["has_elec"]) {
      payloadTA.energies.push("electricity");
    }    
    if (payload["has_gas"]) {
      payloadTA.energies.push("gas");
    }
    if (Object.keys(payload).length) {
      payloadTA.contract_info = payload;
    }

    await store.dispatch("subscription/createSubscriptionTestAchats", payloadTA);

    let subID = store.state.subscription.id;
    let subGuid = store.state.subscription.guid;
    payload["url"] = encodeURI(window.location.href);

    next(`/${subID}/${subGuid}`);
  } catch (error) {
    console.log(error);
  }
  
  return next();
}


// WEBPACK FOOTER //
// ./src/router/middleware/prefill.js